import { useQuery } from 'react-query'
import { useCustomersService } from '../services/customers'
import { Customer } from '../../types'

const useCustomerByGid = (customerGid?: string) => {
  const { getCustomers, isReady: isCustomersReady } = useCustomersService()

  return useQuery<Customer | null>(
    ['customer', customerGid],
    async () => {
      if (!customerGid) return null
      const { data = [] } = await getCustomers({ gid: [customerGid] })
      return data[0] || null
    },
    {
      enabled: Boolean(isCustomersReady && customerGid),
    }
  )
}

export { useCustomerByGid }
